<template>
  <div
    ref="container"
    class="w-full whitespace-nowrap overflow-x-auto drag-scroll-wrapper"
    :class="classes"
    @mousedown="mouseDownHandler"
  >
    <slot />
  </div>
</template>
<script>
/*
* Drag Scroll Vue component
* ---
* Wrapper for contents to allow grab behavior for overflowing contents
*
* Example usage:
* <drag-scroll-wrapper
*   classes=""
* ></drag-scroll-rapper>
*
*/

export default {
  name: 'DragScrollWrapper',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  mounted () {
    const container = this.$refs.container
    container.style.cursor = 'grab'
  },
  methods: {
    mouseDownHandler (e) {
      const container = this.$refs.container
      container.style.cursor = 'grabbing'
      container.style.userSelect = 'none'

      const pos = {
        left: container.scrollLeft,
        top: container.scrollTop,
        x: e.clientX,
        y: e.clientY
      }

      const mouseMoveHandler = (e) => {
        const dx = e.clientX - pos.x
        const dy = e.clientY - pos.y

        container.scrollTop = pos.top - dy
        container.scrollLeft = pos.left - dx
      }

      const mouseUpHandler = () => {
        container.style.cursor = 'grab'
        container.style.removeProperty('user-select')

        document.removeEventListener('mousemove', mouseMoveHandler)
        document.removeEventListener('mouseup', mouseUpHandler)
      }

      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
    }
  }
}
</script>
